import { Capacitor } from '@capacitor/core';
import DownloadAppPoster from './DownloadAppPoster';

// Sezione "Scarica l'app dagli store" in homepage: mostra il poster promo
// (titolo e badge sono nell'immagine, i badge sono cliccabili via DownloadAppPoster).
// Ha senso solo su webapp → in app nativa (iOS/Android) è nascosta.
function DownloadAppFromStore() {
    if (Capacitor.isNativePlatform()) return null;

    return (
        <div className='mt-16 w-full px-6 flex justify-center'>
            <DownloadAppPoster className='w-full max-w-[560px]' />
        </div>
    );
}

export default DownloadAppFromStore;
